<template>
  <v-container fluid class="pa-10">
    <v-row justify="end">
      <v-col align="start">
        <span class="text-h5 text-center bold">OBJETIVOS</span>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        O presente programa tem como objetivo não só promover espaços para
        acesso à alfabetização de jovens e adultos, mas também para o
        aprimoramento das ações acadêmicas, apresentando o ambiente real da sala
        de aula e seus conflitos. O trabalho fundamental é transcender a teoria,
        aliado a prática. Na perspectiva de Paulo Freire se torna imprescindível
        a presença de uma educação dialógica, a qual começa com a busca do
        conteúdo programático, sendo que não se dá no encontro pedagógico com os
        educandos e sim quando o educador pergunta o que vai dialogar com os
        últimos, prerrogativa que objetiva nortear as ações desenvolvidas nas
        salas de aula.
      </v-col>
    </v-row>

    <v-row>
      <v-col> São objetivos do PEJA desde sua criação: </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card color="primary" dark shaped>
          <v-card-title>
            Reconstruir a identidade pessoal, social e cidadania, de jovens,
            adultos e idosos, por meio do atendimento das necessidades de
            escolaridade do ensino fundamental</v-card-title
          >
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-card color="pink darken-2" dark shaped>
          <v-card-title>
            Possibilitar aos alunos do Curso de Pedagogia e demais licenciaturas
            do campus experiência de organizar e desenvolver projetos de
            alfabetização de jovens e adultos</v-card-title
          >
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-card color="#1F7087" dark shaped>
          <v-card-title>
            Articular atividades capacitação, pesquisa e discussão de políticas
            públicas no Grupo de Estudos em parceria com a Secretaria Municipal
            de Educação com a participação de professores de salas de
            EJA</v-card-title
          >
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-card color="#d35400" dark shaped>
          <v-card-title>
            Proporcionar espaços de discussão e socialização dos trabalhos
            realizados nas salas de aula de EJA em conjunto com os demais
            educadores do PEJA que atuam nos demais campus
            universitários.</v-card-title
          >
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-card color="#385F73" dark shaped>
          <v-card-title>
            Intervir e oportunizar condições para atuação junto às políticas
            públicas em Educação de Jovens e Adultos.</v-card-title
          >
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    show: false,
  }),
};
</script>

<style scoped>
.bold {
  font-weight: bold;
}
</style>
